<script setup lang="ts">
import ItemHistoryPayment from '@items/item-history-payment.vue';
import {PropType} from "vue";
import {Bill} from "@store/api/interfaces";

const props = defineProps({
	list: {
		type: Array as PropType<Bill[]>,
		required: true
	}
});

console.log(props.list);
</script>

<template>
	<ul class="part-payment-history">
		<li
			v-for="(item, index) in list" :key="index"
			class="part-payment-history__row"
		>
			<item-history-payment
				:bill="item"
				class="part-payment-history__item"
			/>
		</li>
	</ul>
</template>

<style lang="scss">
	.part-payment-history {
		&__row {
			margin-bottom: 0.8rem;
			display: block;
		}
	}
</style>
